import script from "./PbxSiteUrlModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxSiteUrlModal.vue?vue&type=script&setup=true&lang=js"

import "./PbxSiteUrlModal.vue?vue&type=style&index=0&id=d10fb546&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d10fb546"]])

export default __exports__